export const ADMIN_NAV_MENU_ID = 'admin'
export const DASHBOARDS_NAV_MENU_ID = 'dashboards'
export const ENTITIES_NAV_MENU_ID = 'entities'
export const GROUPS_NAV_MENU_ID = 'groups'
export const METRICS_NAV_MENU_ID = 'metrics'
export const RESULTS_NAV_MENU_ID = 'results'
export const RESOURCES_NAV_MENU_ID = 'resources'
export const SETTINGS_NAV_MENU_ID = 'settings'

export const DEFAULT_EXPANDED_NAV_MENU_IDS = [
  RESOURCES_NAV_MENU_ID,
  RESULTS_NAV_MENU_ID,
  GROUPS_NAV_MENU_ID
]

/**
 * Below this viewport height the navbar's header and footer are no
 * longer sticky, so the whole sidebar scrolls as one unit instead of
 * squeezing the middle section into a tiny scroll window.
 */
export const NAVBAR_SCROLL_AS_ONE_MEDIA_QUERY = '@media (max-height: 700px)'

export const NAVBAR_COLLAPSED_TOOLTIP_OFFSET = {
  popper: {
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 16]
        }
      }
    ]
  }
}
